import React from 'react';

const HeaderRow = () => {
    const headerStyle = {
        height: 40,
        boxSizing: 'border-box',
        width: 100,
        color: '#414141',
        fontSize: 15,
        fontWeight: 500,
        border: '1px solid #D7D7D7',
        borderBottomWidth: 0
    };

    return (
        <thead>
            <tr>
                <th style={{ ...headerStyle, minWidth: 80, maxWidth: 80 }}>{window.translate('Action')}</th>
                <th style={{ ...headerStyle, minWidth: 220, maxWidth: 220 }}>{window.translate('Property Name')}</th>
                <th style={{ ...headerStyle, minWidth: 120, maxWidth: 120 }}>{window.translate('Stations')}</th>
                <th style={{ ...headerStyle, minWidth: 120, maxWidth: 120 }}>{window.translate('Property Type')}</th>
                <th style={{ ...headerStyle, minWidth: 120, maxWidth: 120 }}>{window.translate('Start Date')}</th>
                <th style={{ ...headerStyle, minWidth: 60, maxWidth: 60 }}>{window.translate('Weeks')}</th>
                <th style={{ ...headerStyle, minWidth: 120, maxWidth: 120 }}>{window.translate('End Date')}</th>
                <th style={{ ...headerStyle, minWidth: 100, maxWidth: 100 }}>
                    {window.translate('Scheduled')}
                    <br />
                    {window.translate('Spot Count')}
                </th>
                <th style={{ ...headerStyle, minWidth: 100, maxWidth: 100 }}>
                    {window.translate('Live')}
                    <br />
                    {window.translate('Spot Count')}
                </th>
                <th style={{ ...headerStyle, minWidth: 80, maxWidth: 80 }}>{window.translate('Reach')}</th>
                <th style={{ ...headerStyle, minWidth: 80, maxWidth: 80 }}>{window.translate('Reach %')}</th> {/* ASSP-6668 */}
                <th style={{ ...headerStyle, minWidth: 80, maxWidth: 80 }}>{window.translate('Impacts')}</th>
                <th style={{ ...headerStyle, minWidth: 70, maxWidth: 70 }}>{window.translate('OTH')}</th>
                <th style={{ ...headerStyle, minWidth: 110, maxWidth: 110 }}>{window.translate('Off Air Costs')}</th>
                <th style={{ ...headerStyle, minWidth: 140, maxWidth: 140 }}>
                    {window.translate('List Price')}
                    <br />
                    {window.translate('(On Air Media)')}
                </th>
                <th style={{ ...headerStyle, minWidth: 140, maxWidth: 140 }}>
                    {window.translate('Deal Price')}
                    <br />
                    {window.translate('(On Air Media)')}
                </th>
                <th style={{ ...headerStyle, minWidth: 147, maxWidth: 147 }}>
                    {window.translate('Win Price')}
                    <br />
                    {window.translate('(On Air Media)')}
                </th>
            </tr>
        </thead>
    );
};
export default HeaderRow;
